import { LEGAL_UPDATED, PRIVACY_MD } from '../content/legal';
import { Markdown } from '../components/Markdown';

/**
 * Página "Política de Privacidade" (LGPD). O conteúdo (pt-BR) vive em
 * src/content/legal.ts e é renderizado pelo componente Markdown.
 */
export function PrivacyPage(): React.JSX.Element {
  return (
    <>
      <div className="page-head">
        <h1>Política de Privacidade</h1>
        <p>Última atualização: {LEGAL_UPDATED}</p>
      </div>

      <div className="rules-content">
        <Markdown source={PRIVACY_MD} />
      </div>
    </>
  );
}
